import { render, staticRenderFns } from "./RicercaCommessa.vue?vue&type=template&id=8f0da386"
import script from "./RicercaCommessa.vue?vue&type=script&lang=js"
export * from "./RicercaCommessa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports